// Single source of truth for "is this user an admin" on the frontend — mirrors the backend's
// isAdminUser() (recipe-api/utils/subscription-helper.js, also middleware/admin.js#isAdmin()):
// accepts EITHER role === 'admin' OR isAdmin === true, so both legacy (role-only) and newer
// (isAdmin field) records are recognized. /api/auth/me and /api/auth/signin already compute
// this correctly server-side before sending it to the client, so checking isAdmin alone is safe
// today — but every admin-gated check should still go through one function instead of ~25
// inline checks split across two different (and individually incomplete) conventions, so a
// future endpoint that doesn't normalize the field the same way can't silently break admin
// access somewhere.
export function isAdminUser(user?: { role?: string; isAdmin?: boolean } | null): boolean {
  return user?.role === 'admin' || user?.isAdmin === true;
}
